import { render, staticRenderFns } from "./salesYearStat_h.vue?vue&type=template&id=6bfc6e70&"
import script from "./salesYearStat_h.vue?vue&type=script&lang=js&"
export * from "./salesYearStat_h.vue?vue&type=script&lang=js&"
import style0 from "./salesYearStat_h.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "salesYearStat_h.vue"
export default component.exports